import React from 'react'
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs'
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider'
import {DatePicker} from '@mui/x-date-pickers/DatePicker'
import {useUrlParams} from 'services/hooks'
import dayjs from 'dayjs'
import 'dayjs/locale/he'
import 'dayjs/locale/en'
import {heIL, enUS} from '@mui/x-date-pickers/locales'
import storage from 'services/storage'

export default function BasicDatePicker({label, name}) {
    const {urlParams, setUrlParam} = useUrlParams()
    const defaultDate = urlParams[name] ? dayjs(urlParams[name]).startOf('day') : null
    const handleDateChange = (date) => setUrlParam(name, date?.format('YYYY-MM-DD'))

    const currentLanguage = storage.getLanguage() || 'he'
    dayjs.locale(currentLanguage)
    const localeMap = {
        he: heIL,
        en: enUS,
    }

    const currentLocale = localeMap[currentLanguage] || localeMap.he

    return (
        <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale={currentLanguage}
            localeText={currentLocale.components.MuiLocalizationProvider.defaultProps.localeText}>
            <DatePicker
                label={label}
                inputFormat={currentLanguage === 'he' ? 'DD/MM/YYYY' : 'MM/DD/YYYY'}
                onChange={handleDateChange}
                value={defaultDate}
                slotProps={{
                    textField: {
                        variant: 'standard',
                    },
                    field: {clearable: true},
                    actionBar: {
                        actions: ['clear'],
                    },
                }}
            />
        </LocalizationProvider>
    )
}
